import { Notification } from '@components/Notification';
import { createSignal, JSXElement, Show } from 'solid-js';

type Props = {
  text: string | JSXElement;
  rowCount?: boolean;
  class?: string;
};

const GridNotification = (props: Props) => {
  const [removeWarning, setRemoveWarning] = createSignal(true);
  return (
    <Show when={removeWarning() && props.rowCount}>
      <Notification
        sxProps={`border-2! p-[2px]! bg-white ${props.class ?? ''}`}
        type="warning"
        typeIconStyleContainerClasses="p-1!"
        text={props.text}
        onClose={() => {
          setRemoveWarning(false);
        }}
      />
    </Show>
  );
};

export default GridNotification;
